module.exports = __webpack_public_path__ + "img/Flag_of_Grenada.900fa51d.svg";